export default "__VITE_ASSET__ed5090dd__"